/**
 * Shared labels & helpers for anno (aula) & tipologia percorso.
 */
const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII"];
export const YEAR_LABEL = Object.fromEntries(ROMAN.map((r, i) => [i + 1, `${r} anno`]));
export const roman = (y) => ROMAN[y - 1] || String(y);
export const yearsForTrack = (track) => (track === "modulare" ? [1, 2, 3, 4, 5, 6, 7] : [1, 2, 3]);
export const courseYears = (c) => (c?.year_levels?.length ? c.year_levels : c?.year_level ? [c.year_level] : []);
export const yearsLabel = (c) => {
  const ys = courseYears(c);
  if (!ys.length) return "";
  return ys.length === 1 ? YEAR_LABEL[ys[0]] : `${ys.map(roman).join(", ")} anno`;
};
export const sessionYearsLabel = (s) => {
  const ys = s?.year_levels ?? (s?.year_level ? [s.year_level] : []);
  return ys.length ? `${ys.map((y) => ["I", "II", "III"][y - 1]).join(" + ")} anno` : "";
};

export const AULA_LABEL = {
  1: "Aula I anno",
  2: "Aula II anno",
  3: "Aula III anno",
};

export const TRACK_LABEL = {
  residenziale: "Residenziale (3 anni)",
  modulare: "Modulare (7 anni)",
};

export const TRACK_SHORT = {
  residenziale: "Residenziale",
  modulare: "Modulare",
};

export const YEAR_OPTIONS = [1, 2, 3];
export const TRACK_OPTIONS = ["residenziale", "modulare"];

export function trackDurationYears(track) {
  return track === "modulare" ? 7 : track === "residenziale" ? 3 : null;
}

export function labelYear(year) {
  if (!year) return "—";
  return YEAR_LABEL[year] || `${year}° anno`;
}
export function labelAula(year) {
  if (!year) return "—";
  return AULA_LABEL[year] || `Aula ${year}° anno`;
}
export function labelTrack(track) {
  return TRACK_LABEL[track] || "—";
}
